<template>
  <loadingComponent ref="loadingComponent" :loading-text="$t('loading')">
    <div class="wl-container">
      <div class="container-fluid">
        <div v-if="determinesInspectionAction(['updateHouses'])">
          <a
            href="javascript:void(0)"
            @click="addRow"
            class="btn btn-outline-success btn-sm"
          >{{ $t('add_row') }}</a>
        </div>
      </div>
    </div>

    <div class="wl-container">
      <div class="table-responsive">
        <table class="excel-table-2007 fixed-width-table table-hover">
          <thead class="thead-light-blue">
            <tr>
              <th
                v-for="(column, key) in columns"
                :key="`columns-th-${key}`"
                v-if="column[0] !== undefined && column[0].visible"
                class="text-center established-width-380"
              >
                <template v-if="column && Array.isArray(column) && column.length > 0">
                  <div class="btn-group btn-group-toggle">
                    <span
                      v-for="(current_column, current_index) in column"
                      :key="`rows-td-span-${current_index}`"
                      class="established-width-90"
                    >{{ current_column.title }}</span>
                  </div>
                </template>
              </th>
            </tr>
          </thead>
          <tbody
            v-if="getObjectSize(rows) > 0"
          >
            <tr
              v-for="(row, index) in rows"
              :key="`rows-tr-${index}`"
              :id="generateRandomNumber()"
            >
              <td
                v-for="(column, key) in row"
                :key="`rows-td-${key}`"
                v-if="column[0] !== undefined && column[0].visible"
                class="text-center established-width-380"
              >
                <template v-if="column && Array.isArray(column) && column.length > 0">
                  <div class="btn-group btn-group-toggle">
                    <span
                      v-for="(current_column, current_index) in column"
                      :key="`rows-td-span-${current_index}`"
                      class="established-width-90"
                    >
                      <vue-weirdotab
                        v-if="(current_column.editable) && (inspeccion) || (current_column.type === 'checkbox')"
                        :data="current_column"
                        :index="index"
                        :inspeccion="inspeccion"
                      ></vue-weirdotab>
                      <div v-else>
                        <p class="text-center">{{ current_column.value }}</p>
                      </div>
                    </span>
                    <a
                      v-if="mutable && column[0] !== undefined && column[0].visible && column[0].editable && inspeccion && determinesInspectionAction(['delete'])"
                      href="javascript:void(0)"
                      class="text-primary"
                      @click="deleteRow(column)"
                    >
                      <icon name="minus-circle" size="fa-1x"></icon>
                    </a>
                    <a v-else href="javascript:void(0)" class="text-secondary">
                      <icon name="minus-circle" size="fa-1x"></icon>
                    </a>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr class="alert alert-danger">
              <td
                :colspan="getObjectSize(columns)"
                class="text-center"
              >{{ $t('there_is_no_information') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </loadingComponent>
</template>

<script>
import {
  isArray,
  randomString,
  getNumberFormat,
  getNumberFormatPercent,
} from '../plugins/helper'
import {
  getTheLastRow,
  setNewAssignment,
  determinesInspectionAction,
} from '../plugins/helperService'
import ComponentLoading from './Componentloading'

export default {
  name: 'v-weirdo-table-houses',
  components: {
    loadingComponent: ComponentLoading,
  },
  props: ['inspeccion', 'columns', 'mutable', 'limit', 'rows'],
  methods: {
    determinesInspectionAction(permits) {
      if (isArray(permits) && permits.length === 0) {
        return true
      }

      return determinesInspectionAction(permits)
    },
    count(datos) {
      let count = 0

      datos.forEach(rows => {
        count = count + rows.length
      })

      return count
    },
    getObjectSize(data) {
      return this.__checkVariable(data) ? Object.keys(data).length : 0
    },
    getNumberFormat(number) {
      return getNumberFormat(number)
    },
    getNumberFormatPercent(number) {
      return getNumberFormatPercent(number)
    },
    __checkVariable(...v) {
      let i = 0
      let sw = false
      let temp = false

      while (i < Object.keys(v).length && !sw) {
        temp =
          typeof v[i] !== typeof undefined &&
          v[i] !== false &&
          v[i] !== null &&
          v[i] !== ''

        if (!temp) {
          sw = true
        }

        i++
      }

      return temp
    },
    deleteRow(row) {
      if (Array.isArray(row)) {
        row.forEach((r, index) => {
          r.visible = false
        })
      }
    },
    __getTheLastRow(rows) {
      return getTheLastRow(rows)
    },
    __getNewAssignment(rows) {
      return setNewAssignment(rows)
    },
    addRow(e) {
      // Add row
      const row = this.__getTheLastRow(this.rows)
      const tempdata = this.__getNewAssignment(row)
      const length = this.count(this.rows)
      const currentLength = this.count([tempdata])
      const newLength = length + currentLength

      // Apply insertion
      if (newLength <= this.limit) {
        this.rows.push(tempdata)
      }
    },
    __addDisableRow(data, row) {
      return data.find(element => {
        return (
          element.visible === true &&
          element.lugar === row.lugar &&
          element.id === row.id
        )
      })
    },
    __mapObjectData(row) {
      const newtemp = this.__getTheLastRow(row)
      const keys = Object.keys(newtemp)
      const temp = []

      keys.forEach((v, k) => {
        if (newtemp[v] !== undefined) {
          temp[v] = newtemp[v]
        }
      })

      if (temp.length > 0) {
        temp.id = newtemp.id + 1
      }

      return temp
    },
    generateRandomNumber() {
      return randomString(10)
    },
  },
}
</script>
